import React from 'react';
import "../../assets/styles/toggle.css";

const Toggle = ({ checked, onChange, disabled = false }) => {


  return (
    <>
    <label className="mini-toggle">
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={e => onChange(e.target.checked)}
      />
      <span className="slider" />
    </label>
    </>
  )
}

export default Toggle